<template>
  <div class="container" :style="bgColor">
    <SfButton class="sf-button--text" style="font-size:0.75rem" @click="openModal">
      {{ currency }}
    </SfButton>
    <SfBottomModal :is-open="isLangModalOpen" :title="$t('choose_currency')"
      @click:close="isLangModalOpen = !isLangModalOpen" class="modal1">
      <SfList>
        <SfListItem v-for="cies in currencies" :key="cies.name">
          <a :href="switchLocalePath(locale)" @click="setStoreCookie(cies)">
            <SfButton class="sf-button--text">
              <SfCharacteristic class="language">
                <template #title>
                  <span>{{ cies.label }}</span>
                </template>
              </SfCharacteristic>
            </SfButton>
          </a>
        </SfListItem>
      </SfList>
    </SfBottomModal>
  </div>
</template>

<script>
import {
  SfImage,
  SfSelect,
  SfButton,
  SfList,
  SfBottomModal,
  SfCharacteristic
} from '@storefront-ui/vue';
import { ref, computed } from '@nuxtjs/composition-api';
import { addBasePath } from '@vue-storefront/core';
import {
  VSF_CURRENCY_COOKIE
} from '@vue-storefront/core';
import { hexToRGBA } from '@/plugins/utils';
import { usePreviewOrderStore } from '~/stores/previewOrder';
export default {
  components: {
    SfImage,
    SfSelect,
    SfButton,
    SfList,
    SfBottomModal,
    SfCharacteristic
  },
  setup(props, context) {
    const previewOrderStore = usePreviewOrderStore();
    const currency = ref(context.root.$cookies.get(VSF_CURRENCY_COOKIE));
    const isLangModalOpen = ref(false);
    const { locale } = context.root.$i18n;
    // 非en语言时，删除cookie
    const setStoreCookie = (store) => {
      // context.root.$cookies.set(VSF_LOCALE_COOKIE, store.code);
      context.root.$cookies.set(VSF_CURRENCY_COOKIE, store.name, {
        path: '/',
        sameSite: 'Lax',
        maxAge: 3600 * 24 * 365
      });
      currency.value = store.name;
      isLangModalOpen.value = false;
      context.root.$i18n.setNumberFormat(locale, {
        currency: {
          style: 'currency',
          currency: store.name,
          currencyDisplay: 'symbol'
        }
      });
      previewOrderStore.clearCode();
      previewOrderStore.setPrepay_id(null);
      // context.root.$cookies.remove(VSF_COUNTRY_COOKIE);
    };
    const openModal = () => {
      isLangModalOpen.value = !isLangModalOpen.value;
      context.emit('click:open');
    };
    const bgColor = computed(() => {
      if (context?.root?.$options?.$storeConfig?.mall_home_type === 'website') {
        const config = context?.root?.$options?.$mallConfig?.mall_home_artice;
        // js #fff 转成rgba
        if (config?.headerBgColor?.indexOf('rgb') !== -1 && config?.headerBgColor?.indexOf('rgb') !== undefined) {
          return { background: ((config?.headerBgColor || '#ffffff')) };
        } else {
          return { background: (hexToRGBA(config?.headerBgColor || '#ffffff', 0.5)) };
        }
      } else {
        return {};
      }
    });
    return {
      isLangModalOpen,
      addBasePath,
      setStoreCookie,
      currency,
      currencies: computed(() => {
        try {
          return JSON.parse(context?.root?.$options?.$mallConfig?.mall_currency);
        } catch (e) {
          return process.env.currencies;
        }
      }),
      locale,
      openModal,
      bgColor
    };
  }
};
</script>

<style lang="scss" scoped>
.container {
  margin: 0 0 0 5px;

  .modal1 {
    --c-text: #000;
    @include for-mobile{
      margin-bottom:2.65rem;
    }
  }
}

.container {
  // margin: 0 0px;
  // display: flex;
  flex-wrap: nowrap;
  align-items: center;
  // position: relative;

  .sf-bottom-modal {
    z-index: 2;
    left: 0;

    @include for-desktop {
      --bottom-modal-height: 100vh;
    }
  }

  .sf-bottom-modal::v-deep .sf-bottom-modal__close {
    position: var(--circle-icon-position, absolute);
    top: var(--spacer-xs);
    right: var(--spacer-xs);
  }

  .sf-list {
    flex-wrap: wrap;

    .language {
      padding: var(--spacer-sm);

      &__flag {
        margin-right: var(--spacer-sm);
      }
    }

    @include for-desktop {
      display: flex;
    }
  }

  &__lang {
    width: 20px;
    --button-box-shadow: none;
    background: none;
    padding: 0px;
    display: flex;
    align-items: center;
    opacity: 0.5;
    border: none;

    &:hover,
    &--selected {
      opacity: 1;
    }
  }

  .currency {
    color: #1a1a1a;
    width: auto;
  }
}
</style>
